import TableQuestionContainer from '../Containers/TableQuestionContainer';
import LookupValueQuestionContainer from '../Containers/LookupValueQuestionContainer';
import FileQuestionContainer from '../Containers/FileQuestionContainer';
import LocationHierarchyContainer from '../Containers/LocationHierarchyContainer';
import CalculatedValueQuestionContainer from '../Containers/CalculatedValueQuestionContainer';
import AddressQuestionContainer from '../Containers/AddressQuestionContainer';
import UserQuestionContainer from '../Containers/UserQuestionContainer';
import GPSQuestionContainer from '../Containers/GPSQuestionContainer';
import StringQuestionContainer from '../Containers/StringQuestionContainer';
import IntQuestion from './IntQuestion';
import TimeQuestion from './TimeQuestion';
import DateQuestion from './DateQuestion';
import SelectQuestion from './SelectQuestion';
import SkipQuestion from './SkipQuestion';
import SubFormQuestion from './SubFormQuestion';
import LabelQuestion from './LabelQuestion';
import { SubFormField } from './SubFormField';
import LayoutTableQuestion from './LayoutTableQuestion';
import ValidationRuleQuestion from './ValidationRuleQuestion';
import RankOrderQuestion from './RankOrderQuestion';
import DigitalSignatureQuestion from './DigitalSignatureQuestion';

export const Elements = {
  StringQuestion: StringQuestionContainer,
  IntQuestion: IntQuestion,
  TimeQuestion: TimeQuestion,
  DateQuestion: DateQuestion,
  SelectQuestion: SelectQuestion,
  UserQuestion: UserQuestionContainer,
  TableQuestion: TableQuestionContainer,
  SkipQuestion: SkipQuestion,
  CalculatedValueQuestion: CalculatedValueQuestionContainer,
  LookupValuesQuestion: LookupValueQuestionContainer,
  FileQuestion: FileQuestionContainer,
  LocationHierarchyComponent: LocationHierarchyContainer,
  GPSQuestion: GPSQuestionContainer,
  LabelQuestion: LabelQuestion,
  SubFormQuestion: SubFormQuestion,
  SubFormField: SubFormField,
  AddressQuestion: AddressQuestionContainer,
  LayoutTableQuestion: LayoutTableQuestion,
  ValidationRuleQuestion: ValidationRuleQuestion,
  RankOrderQuestion: RankOrderQuestion,
  DigitalSignatureQuestion: DigitalSignatureQuestion
};
